import { toast } from "lib.front/dist";
import { GestionarCodProdTiendaRepositoryImpl } from "../../data/repositories/GestionarCodProdTiendaRepositoryImpl";
import { useApolloClient } from "@apollo/client";
import { GestionarCodProdTiendaDtSourceImplGql } from "../../data/dataSources/GestionarCodProdTiendaDtSourceImplGql";
import { AddDeleteCodProdTIendaParams, GetCodProdTIendaParams } from "../../utils/params/CodProdTIendaParams";
import { AddCodProductoTiendaUseCase } from "../../business/useCases/AddCodProductoTiendaUseCase";
import { DeleteCodProdTiendaUseCase } from "../../business/useCases/DeleteCodProdTiendaUseCase";
import { GetCodProdTiendaTiendaUseCase } from "../../business/useCases/GetCodProdTiendaTiendaUseCase";

export const useGestionarCodProdTienda = () => {
    const apolloClient = useApolloClient();
    const dataSource = new GestionarCodProdTiendaDtSourceImplGql(apolloClient);
    const repository = new GestionarCodProdTiendaRepositoryImpl(dataSource);
    const addCodProductoTienda = async (input: AddDeleteCodProdTIendaParams) => {
        const useCase = new AddCodProductoTiendaUseCase(repository);
        try {
            const recurso = await useCase.call(input);
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    };
    const deleteCodProdTienda = async (input: AddDeleteCodProdTIendaParams) => {
        const useCase = new DeleteCodProdTiendaUseCase(repository);
        try {
            const recurso = await useCase.call(input);
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    };
    const getCodProdTienda = async (input: GetCodProdTIendaParams) => {
        const useCase = new GetCodProdTiendaTiendaUseCase(repository);
        try {
            const recurso = await useCase.call(input);
            if (recurso.isError()) {
                toast.showError(recurso.toString());
                return undefined;
            }
            return recurso.data;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        }
    }
    return { addCodProductoTienda, deleteCodProdTienda, getCodProdTienda }
}